import videojs from 'video.js';
import { throttle } from '../../js/helpers/throttle-debounce';

const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

const defaultOptions = {
  products: [],
  toggleVisibilityListProducts: () => {},
};

export default class ButtonToggleListProducts extends ClickableComponent {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.options = videojs.mergeOptions(defaultOptions, options);
    this.el().querySelector('.vjs-button-toggle-list-products__counter').innerText = this.options.products.length;
    this.setPosition = throttle(100, false, this.setPosition.bind(this));
    this.setListeners();
  }

  setListeners() {
    this.player.one('play', () => {
      // setTimeout чтобы вызвать this.setPosition после того как был показан ChatMessanger
      setTimeout(this.setPosition);
    });

    window.addEventListener('resize', this.setPosition);
  }

  setPosition() {
    const isMobile = [ ...this.player.el_.classList.values() ]
      .some((className) => className.startsWith('vjs-size-w'));
    if (isMobile) {
      const chatMessangerComponent = this.player.getChild('ChatMessanger');
      if (!chatMessangerComponent) return;
      const chatMessangerEl = chatMessangerComponent.el();
      const chatWidth = chatMessangerEl.clientWidth;
      const chatMessangerWrapperStyle = window.getComputedStyle(chatMessangerEl.querySelector('.vjs-chat-messanger-wrapper'));
      const thisEl = this.el();
      thisEl.style.right = `${chatWidth - thisEl.clientWidth - parseFloat(chatMessangerWrapperStyle.paddingLeft)}px`;
    } else {
      this.el().style.right = '';
    }
  }

  createEl() {
    const counter = videojs.dom.createEl('span', {className: 'vjs-button-toggle-list-products__counter'});
    const svgContainer = videojs.dom.createEl('div', {className: 'vjs-button-toggle-list-products__svg-container'});
    svgContainer.insertAdjacentHTML('afterbegin', '<svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.4" cx="18" cy="2" r="2" fill="black"/><circle opacity="0.4" cx="2" cy="2" r="2" fill="black"/><g><path d="M2 2C6.84441 5.33333 13.1556 5.33333 18 2" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"/></g></svg>');
    return videojs.dom.createEl('button', {className: 'vjs-button-toggle-list-products'}, {}, [svgContainer, counter]);
  }

  handleClick() {
    this.options.toggleVisibilityListProducts();
  }

  hide() {
    // Вызывается в list-products.js
    this.el().classList.add('vjs-button-toggle-list-products_hide');
  }

  show() {
    // Вызывается в list-products.js
    this.el().classList.remove('vjs-button-toggle-list-products_hide');
  }
}

Component.registerComponent('ButtonToggleListProducts', ButtonToggleListProducts);
